import React from 'react';

import { Flex } from '@mantine/core';

import { MenuManagementProvider } from 'context/MenuManagementProvider';

import MenuDisplay from 'components/MenuManagement/MenuDisplay/MenuDisplay';
import ErrorBoundary from 'errorBoundary/ErrorBoundary';

export default function MenuManagement() {
  return (
    <Flex direction="column" style={{ flexGrow: 1 }}>
      <ErrorBoundary>
        <MenuManagementProvider>
          <MenuDisplay />
        </MenuManagementProvider>
      </ErrorBoundary>
    </Flex>
  );
}
